import axios from "axios";

import { API_URL } from "constants/base";
import { DateTime } from "luxon";

const JWT = window.sessionStorage.getItem("jwt");

const addPatient = async (data, isDoctor = false) => {
  try {
    if (isDoctor) {
      sendSMS(data.mobile);
    }
    return await axios.post(API_URL + "/requests", data, {
      headers: {
        authorization: "Bearer " + JWT,
      },
    });
  } catch (error) {
    console.log("error", error.response);
    return error.response;
  }
};

const editPatient = async (data, requests) => {
  try {
    return await axios.put(API_URL + `/requests/${data.id}`, data, {
      headers: {
        authorization: "Bearer " + JWT,
      },
    });
  } catch (error) {
    console.log("error", error.response);
  }
};

const getPatients = async () => {
  return await axios
    .get(API_URL + "/requests?_limit=10000000", {
      headers: {
        authorization: "Bearer " + JWT,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
    });
};


const todayMonth = DateTime.now().plus({days: +1}).toISODate() + 'T00:00:00'
const startOfMonth = DateTime.now().startOf('month').toISODate() + 'T00:00:00'
const getMonthPatients = async () => {
  return await axios
    .get(API_URL + "/" + "requests?created_at_lte=" + todayMonth + "&created_at_gte=" + startOfMonth + "&_limit=1000000", {
      headers: {
        authorization: "Bearer " + JWT,
      },
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("error", error);
    });
};

const sendSMS = async (phoneNumber) => {
  var config = {
    method: "post",
    url: `https://api.dent-scan.com/sms?mobile= 962${phoneNumber.substring(
      1
    )}&template=newRequestSMS`,
    headers: {},
  };

  axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
    })
    .catch(function (error) {
      console.log(error);
    });
};

export { addPatient, getPatients, editPatient, sendSMS, getMonthPatients };
